import { Component, OnInit, OnDestroy, ViewChild, Injectable } from '@angular/core';
import { PersonInfoService } from "../../../services/nonanon/person/person-info.service";
import { Subscription } from "rxjs/Subscription";
import { NotificationComponent } from "../../shared/notification.component";
import { AuthService } from "../../../services/auth/auth.service";
import { PersonPhotoService } from '../../../services/nonanon/person/person-photo.service';

@Component({
  selector: 'app-access-code-person-info',
  templateUrl: './access-code-person-info.component.html'
})

export class PersonInfoByAccessCodeComponent implements OnInit, OnDestroy {
  @ViewChild('notification') notificationComponent: NotificationComponent;

  onPersonInfoChangedByAccessCode: Subscription;
  onPersonPhotoChange: Subscription;

  constructor(private personInfoService: PersonInfoService,
    private authService: AuthService,
    private personPhotoService: PersonPhotoService) { }

  errorMessage: string = null;
  hasErrors() {
    return this.errorMessage != null;
  }

  personInfoByAccessCode: any;
  loading: boolean = false;

  ngOnInit() {

    this.loading = true;
    this.personInfoByAccessCode = this.personInfoService.getPersonInfoByAccessCode();

    this.loading = false;

    this.onPersonInfoChangedByAccessCode = this.personInfoService.personInfoChangedByAccessCode
      .subscribe(
        () => {

          this.notificationComponent.animateIfError(this.personInfoService.getResponseInfoByAccessCode());
          if (this.personInfoService.hasErrors()) {
            this.errorMessage = this.personInfoService.getErrorMessage();
            this.notificationComponent.animateErrorAction(this.errorMessage);
          } else {
            this.errorMessage = null;
            this.personInfoByAccessCode = this.personInfoService.getPersonInfoByAccessCode();
            this.notificationComponent.clear();
          }
        });
  }

  ngOnDestroy() {
    this.onPersonInfoChangedByAccessCode.unsubscribe();
  }
}



// WEBPACK FOOTER //
// c:/Projects/YuDRIV/ServicesAPI/YuDriv-ServicesAPI/Enforcement/src/app/components/nonanon/person/access-code-person-info.component.ts